import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cs-header-title-action',
  templateUrl: 'cs-header-title-action.html',
  host: { 'class': 'header-title-action' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsHeaderTitleAction {
  // Component uses ng-content to allow flexible content
}